import { render, staticRenderFns } from "./FileDragDrop.vue?vue&type=template&id=4b972bbe"
import script from "./FileDragDrop.vue?vue&type=script&lang=js"
export * from "./FileDragDrop.vue?vue&type=script&lang=js"
import style0 from "./FileDragDrop.vue?vue&type=style&index=0&id=4b972bbe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports